import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refProposalListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'proposal_number', label: 'Teklif No', sortable: true },
    { key: 'created_at', label: 'Tarih', sortable: true },
    { key: 'customer_name', label: 'Müşteri', sortable: true },
    { key: 'user', label: 'İşlem Yapılan', sortable: true },
    { key: 'representative_user', label: 'Firma Temsilci', sortable: true },
    { key: 'products', label: 'Ürünler', sortable: true },
    { key: 'validity_days', label: 'Teklif Süresi', sortable: true },
    { key: 'actions', label: '' },
  ]
  const perPage = ref(10)
  const totalProposals = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refProposalListTable.value ? refProposalListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalProposals.value,
    }
  })

  const refetchData = () => {
    refProposalListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchProposals = (ctx, callback) => {
    store
      .dispatch('app-proposal/fetchProposals', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data } = response.data
        const { total } = response.data.meta

        callback(data)
        totalProposals.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching proposal list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchProposals,
    tableColumns,
    perPage,
    currentPage,
    totalProposals,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refProposalListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
